import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { initializeI18n, loadTranslationsForLanguage } from '../i18n/i18n.config';

export const useBackendTranslations = (): void => {
  const { flags } = useAuth();
  const { i18n } = useTranslation();
  const { ENABLE_CONTAINER_BACKEND_TRANSLATIONS } = flags || {};
  const language = i18n.resolvedLanguage ?? i18n.language;

  const prevFlagRef = useRef<boolean | undefined>(undefined);
  const prevLanguageRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    const flag = ENABLE_CONTAINER_BACKEND_TRANSLATIONS;
    const flagChanged = prevFlagRef.current !== flag;
    const languageChanged =
      prevLanguageRef.current !== undefined && prevLanguageRef.current !== language;

    if (flagChanged) {
      prevFlagRef.current = flag;
      prevLanguageRef.current = language;
      initializeI18n(flag);
    } else if (languageChanged && flag === true) {
      prevLanguageRef.current = language;
      loadTranslationsForLanguage(flag);
    }
  }, [ENABLE_CONTAINER_BACKEND_TRANSLATIONS, language]);
};
